import React, { Component } from "react";
import Metatags from "../components/metatags";

class Erro404 extends Component {
  render() {
    return (
      <>
        <Metatags
          title={'404 | LEVTY'}
          description={'Página 404'}
          url={window.location.href}
          error={true}
        />
        <div   translate="no" className="notranslate erro404-page">
          <div   translate="no" className="notranslate erro404-container">
            <div   translate="no" className="notranslate error">404</div>
            <div   translate="no" className="notranslate title">Página não encontrada!</div>
            <button className="notranslate btn btn-primary" onClick={() => this.props.history.push("/")}> Retornar ao Home</button>
          </div>
        </div>
      </>
    )
  }
}
export default Erro404;